import { Injectable } from "@angular/core"
import { Router } from "@angular/router"
import { ApiService } from "@services/api.service"
import { WindowService } from "@services/window.service"

@Injectable()
export class AuthGuard {
    constructor(private router: Router) {}

    canActivate() {
        if (localStorage.getItem("currentUser")) {
            return true
        }

        this.router.navigate(["/login"])

        return false
    }
}

@Injectable()
export class NegAuthGuard {
    constructor(
        private router: Router,
        private apiService: ApiService,
        private windowService: WindowService
    ) {}

    canActivate() {
        if (localStorage.getItem("currentUser")) {
            if (
                this.windowService.window.location.href.includes(
                    "redirectToApp=true"
                )
            ) {
                this.apiService
                    .logout(true)

                    .then(() => {
                        localStorage.setItem("redirectToApp", "true")
                    })
            }

            this.router.navigate(["/create"])

            return false
        }

        return true
    }
}
